import React from 'react';
import { AlertCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Barriga dura e estufada no fim do dia', 'Calça apertando mesmo sem comer muito', 'Rosto mais cheio pela manhã', 'Relógio ou anéis mais apertados', 'Sensação de peso depois das refeições', 'Frustração por dietas antigas não funcionarem mais'];
  return <section className="py-16 md:py-24 bg-white" data-id="element-213">
      <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-214">
        <div className="text-center mb-12" data-id="element-215">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-brand-dark mb-6" data-id="element-216">
            Você Não Está "Engordando do Nada".
          </h2>
          <p className="text-lg text-brand-text/80 leading-relaxed max-w-3xl mx-auto" data-id="element-217">
            Existe uma diferença entre gordura real e aquilo que muitas mulheres
            chamam de gordura, mas na verdade pode ser uma combinação de
            retenção de líquido, gases, intestino lento, má digestão, inflamação
            alimentar e mudanças hormonais comuns depois dos 40.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-4 md:gap-6 mb-12" data-id="element-218">
          {problems.map((problem, index) => <div key={index} className="flex items-start p-4 bg-brand-cream rounded-xl border border-brand-sage/50" data-id="element-219">
              <AlertCircleIcon className="w-6 h-6 text-brand-sage-dark mr-3 flex-shrink-0 mt-0.5" data-id="element-220" />
              <span className="text-brand-text font-medium" data-id="element-221">{problem}</span>
            </div>)}
        </div>

        <div className="bg-brand-pink/40 p-6 md:p-8 rounded-2xl text-center border border-brand-pink" data-id="element-222">
          <p className="text-xl md:text-2xl font-serif font-medium text-brand-dark italic" data-id="element-223">
            "Talvez o problema não seja falta de força de vontade. Talvez você
            só esteja usando estratégias feitas para um corpo que mudou."
          </p>
        </div>
      </div>
    </section>;
}